"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.waiting-approval-widget-field-spacing {\n  margin-top: 0.5rem; }\n";
  var fileName = "widg_WaitingApprovalDialog";
  var element = document.querySelector("style[data-sass-component='widg_WaitingApprovalDialog']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var WaitingApprovalDialog = function WaitingApprovalDialog(_ref) {
  var handleWaitingApprovalDialog = _ref.handleWaitingApprovalDialog,
      translatedStringsForWaitingApproval = _ref.translatedStringsForWaitingApproval;
  return /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: _constants.adminSecretListConstants.alertText,
    title: translatedStringsForWaitingApproval.waitingApprovalDialogTitle,
    message: translatedStringsForWaitingApproval.approvalDialogMessage,
    primaryButtonText: translatedStringsForWaitingApproval.waitingApprovalDialogPrimaryButton,
    onSubmit: function onSubmit() {
      handleWaitingApprovalDialog(false);
    },
    height: _constants.adminSecretListConstants.height,
    onCancel: function onCancel() {
      return handleWaitingApprovalDialog(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStringsForWaitingApproval.notifiedText), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.fieldSpacing
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", translatedStringsForWaitingApproval.trackText, " ")));
};

WaitingApprovalDialog.propTypes = {
  handleWaitingApprovalDialog: _propTypes.default.func,
  translatedStringsForWaitingApproval: _propTypes.default.any
};
var _default = WaitingApprovalDialog;
exports.default = _default;